import React, { useState, useEffect } from 'react';
import companyFile from '../files/Company.txt';
function Company() {
  const [text, setText] = useState('');
  useEffect(() => {
    fetch(companyFile)
      .then(response => response.text())
      .then(data => setText(data));
  }, []);
  return (
    <div className="fade-in">
      <div className="page-header">
        <h1 className="page-title">О компании Ironvector</h1>
      </div>
      <div className="card company-text" style={{ maxWidth: '800px', margin: '0 auto', whiteSpace: 'pre-wrap' }}>
        {text}
      </div>
    </div>
  );
}
export default Company;